import { Avatar, Button, ButtonSize } from '@lemon8/design';
import { FC, useCallback, useEffect, useRef } from 'react';
import { IRelatedUserDetail } from 'shared/models';
import { useCTADirectly, useCTADirectlyCallback } from '~/utils/cta';
import { EClickPosition } from 'shared/constant';
import { activeToUser } from '~/utils/active/active-to-user';
import { activeToArticleByRelatedUserPost } from '~/utils/active/active-to-article';

import './style.scss';

export interface IRelatedUserCardProps {
  user: IRelatedUserDetail;
}

export const RelatedUserCard: FC<IRelatedUserCardProps> = (props) => {
  const articleListRef = useRef<HTMLDivElement>(null);
  const { user } = props;

  const handleClickUser = useCTADirectly({
    clickPosition: EClickPosition.RelatedUser,
    clickId: user.userId,
    onClick: useCallback(() => {
      activeToUser(user, EClickPosition.RelatedUser, user.userId);
    }, [user]),
  });

  const handleClickArticle = useCTADirectlyCallback<number>({
    clickPosition: () => EClickPosition.RelatedUser,
    clickId: (index: number) => user.relatedArticles[index].groupId,
    onClick: useCallback(
      (index: number) => {
        activeToArticleByRelatedUserPost(
          user.relatedArticles[index],
          user,
          EClickPosition.RelatedUser,
          user.relatedArticles[index].groupId,
        );
      },
      [user],
    ),
  });

  useEffect(() => {
    if (!articleListRef.current) {
      return;
    }

    const articleList = articleListRef.current;

    const stopPropagation = (e: TouchEvent) => {
      e.stopPropagation();
    };

    articleList.addEventListener('touchstart', stopPropagation, {
      passive: false,
    });

    return () => {
      articleList.removeEventListener('touchstart', stopPropagation);
    };
  }, []);

  return (
    <div className="related-user-card">
      <div className="related-user-card-head">
        <Avatar onClick={handleClickUser} className="related-user-card-head-avatar" size={36} src={user.avatar} />
        <div className="related-user-card-head-user" onClick={handleClickUser}>
          <span className="related-user-card-head-user-title">{user.nickName}</span>
          <p className="related-user-card-head-user-desc">{user.recommendReason}</p>
        </div>
        <Button onClick={handleClickUser} variant={'Primary'} size={ButtonSize.small} title={'Follow'} />
      </div>
      <div className="related-user-card-content" ref={articleListRef}>
        {user.relatedArticles.map((article, index) => (
          <div key={article.groupId} className="related-user-card-content-item">
            <img
              loading="lazy"
              onClick={handleClickArticle(index)}
              className="related-user-card-content-item-img"
              src={article.cover.url}
            />
            <p className="related-user-card-content-item-desc" onClick={handleClickArticle(index)}>
              {article.title || article.shortContent || ''}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
